import './styles.css';
import { StyleProvider } from '@ant-design/cssinjs';
import { App as AntApp, ConfigProvider } from 'antd';
import enGB from 'antd/locale/en_GB';
import { StrictMode, useMemo, type ReactNode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { CurrentUserProvider } from './shared/features/session/components/CurrentUserProvider';
import { OrganizationProvider } from './shared/features/organization/components/OrganizationProvider';
import { router } from './app/app.routes';
import { ColorModeProvider, useColorMode } from './shared/features/theme/components/ColorModeProvider';
import { buildTheme } from './shared/features/theme/adapters/theme';

function ThemedApp({ children }: { children: ReactNode }) {
  const { mode } = useColorMode();
  const theme = useMemo(() => buildTheme(mode), [mode]);
  // `layer` puts Ant's styles in @layer antd (see styles.css) so Tailwind utilities can override them.
  return (
    <StyleProvider layer>
      <ConfigProvider theme={theme} locale={enGB} componentSize="small">
        <AntApp>{children}</AntApp>
      </ConfigProvider>
    </StyleProvider>
  );
}

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <ColorModeProvider>
      <ThemedApp>
        <OrganizationProvider>
          <CurrentUserProvider>
            <RouterProvider router={router} />
          </CurrentUserProvider>
        </OrganizationProvider>
      </ThemedApp>
    </ColorModeProvider>
  </StrictMode>,
);
